import styles from './IconDefault.module.scss';

export function IconActivity() {
	return (
		<svg
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={styles.mediumIllustration}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M38.9838 20.7713C38.9946 20.5156 39 20.2584 39 20C39 10.0589 30.9411 2 21 2C11.0589 2 3 10.0589 3 20C3 20.2584 3.00545 20.5156 3.01623 20.7713H6.76863C6.99376 20.7713 7.19112 20.6209 7.25076 20.4038L8.26804 16.7009C8.90992 14.3645 12.1672 14.2159 13.0191 16.4842L17.1825 27.5695L23.7245 8.55245C24.5243 6.22741 27.8479 6.33249 28.4992 8.70341L31.7136 20.4038C31.7733 20.6209 31.9707 20.7713 32.1958 20.7713H38.9838ZM38.6043 23.7713H32.1958C30.6199 23.7713 29.2383 22.7181 28.8208 21.1985L26.035 11.0583L19.5672 29.8597C18.8049 32.0757 15.6867 32.1192 14.8628 29.9255L10.7526 18.9819L10.1436 21.1985C9.7261 22.7181 8.34453 23.7713 6.76863 23.7713H3.39571C5.12906 31.9019 12.3524 38 21 38C29.6476 38 36.8709 31.9019 38.6043 23.7713Z"
				fill="var(--coral-color-illustration-color-03, hsla(0,100%,74%,1))"
			/>
			<path
				d="M1.64247 21.2713H5.76863C6.66915 21.2713 7.45861 20.6695 7.69717 19.8011L8.71445 16.0983C8.9712 15.1637 10.2741 15.1043 10.6149 16.0116L15.267 28.3981C15.5966 29.2756 16.8438 29.2582 17.1487 28.3718L24.1429 8.0404C24.4629 7.11038 25.7923 7.15241 26.0528 8.10078L29.2672 19.8011C29.5058 20.6695 30.2953 21.2713 31.1958 21.2713H33.125"
				stroke="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<circle
				cx="36.4375"
				cy="21.3125"
				r="1"
				fill="var(--coral-color-illustration-color-02, hsla(215,69%,27%,1))"
			/>
		</svg>
	);
}
